export default [
    {
        path: '/v3/user/login',
        component: () => import('@/pages/v2/login'),
    },
    {
        path: '/v3/password/forget',
        component: () => import('@/pages/v2/password-forget'),
    },
    {
        path: '/v3/user/register',
        component: () => import('@/pages/v2/register'),
    },
    {
        path: '/v3/user/download',
        component: () => import('@/pages/v2/download/download'),
    },
    {
        path: '/v3/user/download-register',
        component: () => import('@/pages/v2/download/download-register'),
    },
    {
        path: '/v3/user/download-process',
        component: () => import('@/pages/v2/download/download-process'),
    },
    {
        path: '/v3/user/download-store',
        component: () => import('@/pages/v2/download/download-store'),
    },
    {
        path: '/v3/user/view-reference-id',
        component: () => import('@/pages/v2/download/view-reference-id'),
    },
  ];
  


// WEBPACK FOOTER //
// ./src/router/v2/login.js